import NETWORK from './network';

export const CONTRACT_ADDRESS = NETWORK.contractAddress;

export const CONTRACT_ABI = [
  "function register(uint256 referrerId) external",
  "function upgradePackage(uint256 packageId) external",
  "function retopupPackage(uint256 packageId) external",
  "function claimIncome() external",
  "function claimAllPoolIncomes() external",
  "function claimGoldPoolIncome() external",
  "function claimPlatinumPoolIncome() external",
  "function claimDiamondPoolIncome() external",
  "function claimCrownPoolIncome() external",
  "function claimBluePoolIncome() external",
  "function claimAmbassadorPoolIncome() external",
  "function p(uint256 op, uint256 a1, uint256 a2) external",
  "function usdt() view returns (address)",
  "function owner() view returns (address)",
  "function admin() view returns (address)",
  "function defaultReferrer() view returns (uint256)",
  "function packagePrices(uint256) view returns (uint256)",
  "function totalUsers() view returns (uint256)",
  "function addressToId(address) view returns (uint256)",
  "function withdrawFeePercent() view returns (uint256)",
  "function goldPoolAccumulation() view returns (uint256)",
  "function platinumPoolAccumulation() view returns (uint256)",
  "function diamondPoolAccumulation() view returns (uint256)",
  "function crownPoolAccumulation() view returns (uint256)",
  "function bluePoolAccumulation() view returns (uint256)",
  "function ambassadorPoolAccumulation() view returns (uint256)",
  "function goldEligibleCount() view returns (uint256)",
  "function platinumEligibleCount() view returns (uint256)",
  "function diamondEligibleCount() view returns (uint256)",
  "function crownEligibleCount() view returns (uint256)",
  "function blueEligibleCount() view returns (uint256)",
  "function ambassadorEligibleCount() view returns (uint256)",
  "function missingIncomePool() view returns (uint256)",
  "function getUserDetails(uint256 userId) view returns (address account, uint256 id, uint256 referrer, bool isActive, uint256 totalDirectReferrals, uint256 claimableAmount, uint256 totalClaimed, uint256 totalIncome)",
  "function getUserPackageDetails(uint256 userId, uint256 packageId) view returns (bool isActive, uint256 activationTime, uint256 totalInvested, uint256 totalEarned, uint256 ceilingLimit, uint256 remainingLimit)",
  "function getUserPackages(uint256 userId) view returns (bool[6] activePackages)",
  "function getMatrixDetails(uint256 userId, uint256 packageId) view returns (uint256 upline, uint256[] directDownlines, uint256 totalTeamSize)",
  "function getUserIncomeBreakdown(uint256 userId) view returns (uint256 sponsorIncome, uint256 levelIncome, uint256 goldPoolIncome, uint256 platinumPoolIncome, uint256 diamondPoolIncome, uint256 crownPoolIncome, uint256 bluePoolIncome, uint256 ambassadorPoolIncome, uint256 totalIncome, uint256 claimableAmount, uint256 totalClaimed)",
  "function getUserReferrals(uint256 userId) view returns (uint256[])",
  "function getPoolEligibilities(uint256 userId) view returns (bool goldEligible, bool platinumEligible, bool diamondEligible, bool crownEligible, bool blueEligible, bool ambassadorEligible)",
  "function getUserClaimablePoolIncomes(uint256 userId) view returns (uint256 goldClaimable, uint256 platinumClaimable, uint256 diamondClaimable, uint256 crownClaimable, uint256 blueClaimable, uint256 ambassadorClaimable)",
  "function getMatrixLevelUsers(uint256 userId, uint256 packageId, uint256 level) view returns (uint256[])",
  "function getMatrixLevelCounts(uint256 userId, uint256 packageId) view returns (uint256[12] levelCounts)",
  "function getPoolDistributionInfo(uint256 poolType) view returns (uint256 currentRound, uint256 latestAmountPerUser, uint256 totalRounds)",
  "function getUserActivities(uint256 userId) view returns (tuple(uint256 id, uint256 userId, uint256 activityType, uint256 amount, uint256 packageId, uint256 fromId, uint256 timestamp)[])",
  "function getMissingPoolBalance() view returns (uint256)",
  "function getTotalUsers() view returns (uint256)",
  "function getUserIdByAddress(address userAddress) view returns (uint256)",
  "function getPoolAccumulations() view returns (uint256 gold, uint256 platinum, uint256 diamond, uint256 crown, uint256 blue, uint256 ambassador)",
  "function getPoolEligibleCounts() view returns (uint256, uint256, uint256, uint256, uint256, uint256)",
  "function getContractBalance() view returns (uint256)"
];
